import React from "react";
import { makeStyles } from "tss-react/mui";

import { Box, Theme } from "@mui/material";

const useStyles = makeStyles()((muiTheme: Theme) => ({
    gridContainer: {
        display: "grid",
        gridTemplateColumns: "repeat(auto-fill, minmax(220px, 1fr))",
        gap: muiTheme.spacing(2),
        padding: muiTheme.spacing(3, 0),
    },
}));

type FeatureTilesGridProps = {
    children: React.ReactNode;
};

export const FeatureTilesGrid = (props: FeatureTilesGridProps) => {
    const { classes } = useStyles();
    const { children } = props;

    return <Box className={classes.gridContainer}>{children}</Box>;
};
